import { Model } from '../parents/model';

export class OrderStateModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_LABEL = 'label';
  static ATTR_COLOR = 'color';
  static ATTR_TEXT_COLOR = 'text_color';
  static ATTR_MAKES_SHIPPED = 'makes_shipped';
  static ATTR_MAKES_CANCELLED = 'makes_cancelled';
  static ATTR_MAKES_COMPLETED = 'makes_completed';
  static ATTR_MAKES_PAID = 'makes_paid';

  get label() {
    return this.attributes[OrderStateModel.ATTR_LABEL];
  }

  get color() {
    return this.attributes[OrderStateModel.ATTR_COLOR];
  }

  get textColor() {
    return this.attributes[OrderStateModel.ATTR_TEXT_COLOR] || '#FFFFFF';
  }

  get makesShipped() {
    return this.attributes[OrderStateModel.ATTR_MAKES_SHIPPED];
  }

  get makesCancelled() {
    return this.attributes[OrderStateModel.ATTR_MAKES_CANCELLED];
  }

  get makesCompleted() {
    return this.attributes[OrderStateModel.ATTR_MAKES_COMPLETED];
  }

  get makesPaid() {
    return this.attributes[OrderStateModel.ATTR_MAKES_PAID];
  }
}
